var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 12,
    viewBox: "0 0 34 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9093 0.703848L8.45799 11.3242H5.55384L3.36333 2.84867C3.23034 2.32663 3.1147 2.13538 2.71025 1.91545C2.04991 1.55721 0.959433 1.22111 0 1.0125L0.0651663 0.703848H4.73997C5.33585 0.703848 5.87152 1.10051 6.00681 1.78671L7.16369 7.93217L10.0229 0.703671H12.9093V0.703848ZM24.2883 7.85674C24.3 5.0537 20.4123 4.89928 20.439 3.64713C20.4474 3.26605 20.8102 2.86089 21.6044 2.75747C21.9981 2.70594 23.0827 2.66663 24.3129 3.23276L24.7954 0.980628C24.1344 0.740681 23.2839 0.509766 22.2256 0.509766C19.5101 0.509766 17.599 1.95334 17.5829 4.02042C17.5653 5.54935 18.9469 6.40254 19.9878 6.91059C21.0586 7.43085 21.4179 7.76519 21.4139 8.23056C21.4063 8.94296 20.5598 9.25746 19.7688 9.26985C18.3879 9.29111 17.5866 8.89621 16.9478 8.59924L16.4499 10.9259C17.0918 11.2204 18.2767 11.4774 19.5051 11.4903C22.3914 11.4903 24.2794 10.0646 24.2883 7.85674ZM31.459 11.3242H34L31.782 0.703848H29.4368C28.9094 0.703848 28.4646 1.01091 28.2677 1.48301L24.145 11.3242H27.0299L27.6025 9.73788H31.1274L31.459 11.3242ZM28.3936 7.56119L29.8396 3.57365L30.6719 7.56119H28.3936ZM16.8347 0.703848L14.5629 11.3242H11.8156L14.0883 0.703848H16.8347Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visaIcon.3bcde9a1b153576c73b42a9a3f1f9626.svg";
export { ForwardRef as ReactComponent };